import styled, { css } from 'styled-components';
import { rem } from '../../utils';
export const StyledContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;
export const StyledLabelContainer = styled.div `
  display: flex;
  width: 100%;
  ${({ theme }) => css `
    height: ${rem(theme.Form.InputSize.Medium.height)};
  `}
  user-select: none;
  word-wrap: break-word;
  white-space: nowrap;
  align-items: center;

  cursor: pointer;

  ${({ theme, isOpened }) => css `
    border: ${rem(theme.Border.Size.Small)} solid
      ${isOpened ? theme.Color.System.Primary : theme.Color.Neutrals.Border};
    border-radius: ${rem(theme.Border.Radius.Small)};
    padding: 0 ${rem(theme.Spacing.Size.XSmall)};
  `}
`;
export const StyledIconWrapper = styled.div `
  display: flex;
  align-items: center;
  margin-left: auto;
`;
export const StyledLabel = styled.label `
  display: flex;
  width: 100%;
  align-items: left;
  padding: 0 0 ${({ theme }) => rem(theme.Spacing.Size.XSmall)} 0;
`;
//# sourceMappingURL=Select.style.js.map